import { useEffect } from "react";

export default function useDismissOnOutsideClick(active, rootRef, onDismiss) {
  useEffect(() => {
    if (!active) return undefined;

    const handlePointerDown = (event) => {
      const root = rootRef.current;
      if (root && event.target && root.contains(event.target)) return;
      onDismiss();
    };

    document.addEventListener("mousedown", handlePointerDown);
    return () => document.removeEventListener("mousedown", handlePointerDown);
  }, [active, onDismiss, rootRef]);
}
